import { Button } from '@acpaas-ui/react-components';
import StaticTable from '../../../containers/core/StaticTable';
import { useForm } from '../../../hooks/useForm.hook';
import { useResourceInput } from '../../../hooks/useResourceInput';
import { MEASURE_MOMENTS_RESOURCE } from '../../../resources/measure.moments.resource';
import procedureService from '../../../services/api/procedure.service';
import TextField from '../../forms/TextField';

const DossierProcedureIndicator = ({
  write,
  id,
  dossierId,
  goalId,
  name,
  measureMoments,
  onDelete,
  onUpdated,
  onMeasureMomentAdd,
  onMeasureMomentOpen
}) => {
  const { isSubmitting, data, reset, input, submitStart, submitOk, submitError } = useForm({
    id,
    name,
    measureMoments
  });
  const resource = {
    isFetching: false,
    isSubmitting,
    getValue: (field) => data?.[field],
    setValue: (value, field, options = {}) => {
      submitStart();
      procedureService.updateGoalIndicator(
        dossierId,
        goalId,
        data?.id,
        { [field]: value },
        {
          onSuccess: () => {
            submitOk();
            input(value, field);
            onUpdated(value, field, data?.id);
            options.onSuccess();
          },
          onError: (message) => {
            submitError({ [field]: message });
            options.onError(message);
          }
        }
      );
    },
    onCancel: reset
  };

  return (
    <div className="spo-m-dossier-procedure-indicator">
      <div className="spo-m-dossier-procedure-indicator__name u-margin-bottom">
        <div className="spo-m-dossier-procedure-indicator__name-text-wrapper">
          <TextField label="Naam indicator" {...useResourceInput('name', resource)} readOnly={!write} />
        </div>
        {write && <Button icon="ai-bin" type="danger" transparent onClick={onDelete} />}
      </div>
      <StaticTable
        resource={{ ...MEASURE_MOMENTS_RESOURCE, key: `${MEASURE_MOMENTS_RESOURCE.key}_${id}` }}
        data={measureMoments}
        onRowClick={onMeasureMomentOpen}
        actions={
          write && [
            <Button
              key="measure-moment-add"
              size="small"
              className="u-margin-right-sm"
              iconRight="ai-add"
              onClick={() => onMeasureMomentAdd(id)}
            >
              Meetmoment toevoegen
            </Button>
          ]
        }
      />
    </div>
  );
};

export default DossierProcedureIndicator;
